module.exports = function getResource(label) {
    const resources = { qty: 'Quantity' };
    return resources[label];
};
